import { useContext } from 'react'
import { SidenavItemsExpandedContext } from 'src/context/SidenavItemsExpandedContext/SidenavItemsExpandedContext'

export default function useSidenavItemsExpanded() {
  const sidenavItemsExpandedContext = useContext(SidenavItemsExpandedContext)

  return sidenavItemsExpandedContext
}
